export default "__VITE_ASSET__DXutrbyK__"